import { render, staticRenderFns } from "./unidade.vue?vue&type=template&id=4595e0a7&"
import script from "./unidade.vue?vue&type=script&lang=js&"
export * from "./unidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports